<template>
    <div class="loading absolute h-screen text-center">
        <!-- <img class="" src="https://media2.giphy.com/media/RHEqKwRZDwFKE/100.webp?cid=ecf05e47mmznyh7mm3mon7kpqk6p2kekvqku62v5lnwpbhx5&ep=v1_gifs_search&rid=100.webp&ct=g" alt="" width="200" /> -->
        <!-- <img class="" src="https://media0.giphy.com/media/4T1NFafropdQOrBYw6/giphy.webp?cid=ecf05e47mj5w8v7ne0vdms5rke5ny5s7drr8a5ozkblpuwam&ep=v1_gifs_search&rid=giphy.webp&ct=g" alt="" width="600" /> -->
        <!-- <img class="" src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExanhiYm9nNWMwY2lvazEzdm9vYmFiYjZrNnpqNTdqajNvcjlranY1NSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/vjZkgd6XlhPHSZgQNY/200.webp" alt="" width="600" /> -->
        <!-- <img class="" src="https://media2.giphy.com/media/xT0BKiaM2VGJ553P9K/giphy.webp?cid=ecf05e47q4llogpxyt0bw7ulyt5z8s0a7mswsdjpjynddqsj&ep=v1_gifs_search&rid=giphy.webp&ct=g" alt="" width="600" /> -->
    </div>
    
</template>
  
<script setup lang="ts">

</script>
<style lang="scss"></style>


<style>
.loading {
    z-index: 1000;
    background-color: white;
    width: 100vw;
    line-height: 100vh;
}
</style>